import React, { useEffect, useState } from 'react'
import { useAuthContext } from '../../../hooks/useAuthContext'
import axios from 'axios';
import { ApiConnectionString } from '../../../constants/ApiConntection';
import PractitionerProfileForm from '../practitionerProfileForm/PractitionerProfileForm';
import Overview from '../overview/Overview';

export default function LoggedIn() {

    const {user} = useAuthContext();    
    const [profile,setProfile] = useState(null); 
    
  
    
     const fetchData = async () => {
    const response = await axios.get(
      `${ApiConnectionString}/api/counsellorProfile/`,
      {
        headers: { Authorization: `bearer ${user.token}` },
      } 
    );
    setProfile(response.data);
  };

  useEffect(() => {
    fetchData();
  }, []);


  if(profile){
  return (
    <div>
        {profile.complete ?  <Overview profile={profile} user={user} /> : <PractitionerProfileForm fetchData={fetchData} value={profile} user={user}/>}

    </div>
  )
}
}